// extracted by mini-css-extract-plugin
export default {"leftMenu_overlay":"HorizontalLayout_leftMenu_overlay__vN7ld"};